import React, { useState, useEffect } from "react";
import {
  Table,
  Input,
  Space,
  Card,
  Radio,
  Tooltip,
  Modal,
  Form,
  Select,
  message,
  Button,
} from "antd";

import { Columns } from "./columns";
import { useParams } from "react-router-dom";
import { orderStatus, shipStatus } from "utility/options/index";

import {
  apiGetOrder,
  apiPutOrder,
  apiPutResend,
  apiGetTickets,
  apiRefund,
  apiGetCreateOrderFiles,
  apiGetExportFiles,
  apiSwitchTicket,
} from "api/api";

const JoinList = () => {
  const { id } = useParams();
  const [form] = Form.useForm();
  const [switchForm] = Form.useForm();
  const [reasonForm] = Form.useForm();

  const [total, setTotal] = useState(0);
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [radio, setRadio] = useState(1);
  // # 訂單編號
  const [orderDetailId, setOrderDetailId] = useState(null);

  // # 取得資料
  const [dataSource, setDataSource] = useState([]);
  const [movieOptions, setMovieOptions] = useState([]);
  const [record, setRecord] = useState({});
  const [isDataLoading, setIsDataLoading] = useState(false);
  // # 匯出資料 btn
  const [isExportBtnLoading, setIsExportBtnLoading] = useState(false);

  // # 搜尋欄位
  const [fuzzySearch, setFuzzySearch] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [movieTargetId, setMovieTargetId] = useState("");

  // # 換票
  const [isSwitchModalOpen, setIsSwitchModalOpen] = useState(false);
  const [isSwitchConfirmLoading, setIsSwitchConfirmLoading] = useState(false);

  // # 退票
  const [isRefundModalOpen, setIsRefundModalOpen] = useState(false);
  const [refund, setRefund] = useState([]);
  // # 退票原因
  const [isRefundReasonModalOpen, setIsRefundReasonModalOpen] = useState(false);
  const [isRefundReasonLoading, setIsRefundReasonLoading] = useState(false);

  const fetchData = async () => {
    setIsDataLoading(true);
    try {
      const res = await apiGetOrder({
        sourceId: id,
        status: radio,
        fuzzySearch,
        specificSourceId: movieTargetId,
        offset: current * pageSize - pageSize,
        limit: pageSize,
      });
      const { content, paging } = res.data;
      // # 為每一筆資料加上key
      content.map((c) => (c.key = c.id));
      setDataSource(content);
      setTotal(paging.count);
      setIsDataLoading(false);
    } catch (err) {
      console.log(("ERR", err));
    } finally {
    }
  };

  useEffect(() => {
    fetchData();
  }, [radio, fuzzySearch, movieTargetId, current, pageSize]);

  // # 單選

  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    setRadio(e.target.value);
  };

  // # 搜尋
  const { Search } = Input;
  const onSearch = (value) => {
    setFuzzySearch(value);
    // setOrderDetailId(Number(value));
  };

  // # 下拉電影名稱
  const handleChange = (value) => {
    setMovieTargetId(value);
  };

  // # 下拉電影名稱選項
  // # 獲取資料
  const fetchOptions = async () => {
    setIsDataLoading(true);
    try {
      const res = await apiGetTickets({ id, limit: 100 });
      console.log(res);
      const { content } = res.data;
      let options = content.map((item) => {
        return { label: item.title, value: item.id, price: item.price };
      });
      setMovieOptions(options);
    } catch (err) {
      console.log("errr", err);
    } finally {
      setIsDataLoading(false);
    }
  };

  useEffect(() => {
    fetchOptions();
  }, [radio]);

  // # 表格
  const signUp = async (record) => {
    // 人工簽到
    try {
      const res = await apiPutOrder({ shipStatus: 2, detailId: record.id });
      message.success("已完成驗票");
    } catch (error) {
      console.log("err", error);
    } finally {
      fetchData();
    }
  };
  const edit = (record) => {
    setRecord(record);
    setIsModalOpen(true);
  };

  const onTableChange = (pagination) => {
    setCurrent(pagination.current);
  };

  // # 變更每頁顯示數量
  const onShowSizeChange = (current, pageSize) => {
    setPageSize(pageSize);
  };

  useEffect(() => {
    form.setFieldsValue(record);
  }, [record]);

  const resend = async (record) => {
    message.warning("已送出「重新發送」需求");
    // 補發票券
    try {
      const res = await apiPutResend({ detailId: record.id });
      message.success(`票券已經重新發送給「${record.name}」`);
    } catch (error) {
      message.error(error.response.data.message);
    } finally {
      fetchData();
    }
  };

  // # 換票彈窗開啟
  const switchTicket = async (record) => {
    setRecord(record);
    setIsSwitchModalOpen(true);
  };

  // # 編輯彈窗送出
  const handleOk = async () => {
    try {
      const sendForm = form.getFieldsValue();
      const newSendForm = { ...sendForm, detailId: sendForm.id };
      const res = await apiPutOrder(newSendForm);
      message.success("更新成功");
    } catch (error) {
      console.log(error);
      message.error(error.response.data.message);
    } finally {
      fetchData();
      setIsModalOpen(false);
    }
  };

  // # 換票彈窗送出
  const handleSwitchOk = async () => {
    setIsSwitchConfirmLoading(true);
    try {
      const sendForm = switchForm.getFieldsValue();
      const newSendForm = { id: record?.id, sourceId: sendForm?.sourceId };
      const res = await apiSwitchTicket(newSendForm);
      message.success("換票成功！");
    } catch (error) {
      console.log(error);
      message.error(error.response.data.message);
    } finally {
      fetchData();
      setIsSwitchConfirmLoading(false);
      setIsSwitchModalOpen(false);
    }
  };

  // # 編輯彈窗取消
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // # 換票彈窗取消
  const handleSwitchCancel = () => {
    setIsSwitchModalOpen(false);
  };

  // # 退票「原因」彈窗，開啟
  const handleRefundReasonModalOpen = () => {
    console.log("現在長度", refund);
    if (refund.length === 0) message.error("請至少選擇一筆");
    else setIsRefundReasonModalOpen(true);
  };

  // # 退票「原因」彈窗，送出
  const handleRefundOk = async () => {
    const reason = reasonForm.getFieldValue("reason");
    setIsRefundReasonLoading(true);
    try {
      const res = await apiRefund(refund, reason);
      message.success("退票完成");
      setIsRefundModalOpen(false);
      setIsRefundReasonModalOpen(false);
      setIsRefundReasonLoading(false);
    } catch (error) {
      message.error(error.response.data.message);
    } finally {
      setTimeout(() => {
        fetchData();
      }, 500);
      setRefund([]);
    }
  };

  // # 退票彈窗取消
  const handleRefundCancel = () => {
    setFuzzySearch("");
    setIsRefundModalOpen(false);
    setRefund([]);
  };

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(
        `selectedRowKeys: ${selectedRowKeys}`,
        "selectedRows: ",
        selectedRows,
      );
      setRefund(selectedRowKeys);
    },
    getCheckboxProps: (record) => ({
      disabled: record.name === "Disabled User",
      // Column configuration not to be checked
      name: record.name,
    }),
  };

  // # 製作檔案
  const handleDownload = async () => {
    setIsExportBtnLoading(true);
    try {
      const res = await apiGetCreateOrderFiles({ sourceId: id });
      const { content } = res.data;
      await exportFile(content);
    } catch (error) {
      message.error(error?.response?.data?.message);
    }
  };

  // # 匯出檔案
  const exportFile = async (id) => {
    try {
      const res = await apiGetExportFiles({ id });
      const { content } = res.data;
      window.open(content);
      message.success("匯出成功");
    } catch (error) {
      message.error(error?.response?.data?.message);
    } finally {
      setIsExportBtnLoading(false);
    }
  };

  const columns = Columns({
    signUp,
    edit,
    resend,
    switchTicket,
    type: radio,
  }).map((column) => {
    if (column.key === "policyStatus") {
      return {
        ...column,
        render: (text) => {
          let backgroundColor = "";
          switch (text) {
            case "已更換":
              backgroundColor = "#d4edda"; // 淺綠色
              break;
            case "申請退款":
              backgroundColor = "#ffeeba"; // 淺橘色
              break;
            case "已退款":
              backgroundColor = "#f8d7da"; // 淺紅色
              break;
            default:
              backgroundColor = ""; // 無背景色
          }
          return (
            <span
              style={{ backgroundColor, padding: "5px", borderRadius: "4px" }}
            >
              {text}
            </span>
          );
        },
      };
    }
    return column;
  });

  return (
    <>
      <h2 className="text-Gray-8 mb-0">參加名單</h2>
      <p className="m-0 text-Gray-5">本場活動參與的會員。</p>
      <Card
        title={<h3 className="text-left">參加名單</h3>}
        className="text-center mt-5 rounded-3xl px-0 min-h-[calc(100vh-250px)] [&_.ant-card-body]:text-right"
        extra={
          <Button
            loading={isExportBtnLoading}
            type="primary"
            onClick={handleDownload}
          >
            匯出全部
          </Button>
        }
      >
        <div className="flex flex-col lg:flex-row gap-4 w-full mb-5 text-left items-start lg:items-center">
          <div className="flex flex-col md:flex-row gap-4 w-full lg:w-auto">
            <Search
              onSearch={onSearch}
              className="w-full md:w-64"
              placeholder="訂單編號 / 姓名 / 電話 / Email"
              enterButton
              allowClear={true}
            />
            <Select
              placeholder="電影名稱"
              className="w-full md:w-48"
              onChange={handleChange}
              options={movieOptions}
            />
          </div>
          <Radio.Group
            onChange={onChange}
            value={radio}
            optionType="button"
            buttonStyle="solid"
            className="flex flex-wrap gap-2 [&_.ant-radio-button-wrapper]:rounded-md [&_.ant-radio-button-wrapper::before]:hidden [&_.ant-radio-button-wrapper]:border-s"
          >
            <Radio value={1}>訂單未付款</Radio>
            <Radio value={2}>訂單待確認</Radio>
            <Radio value={4}>訂單已付款</Radio>
            <Radio value={8}>整筆訂單退款</Radio>
            <Radio value={16}>部分訂單退款</Radio>
            <Radio value={32}>建立失敗</Radio>
          </Radio.Group>
        </div>
        {radio == 4 && (
          <Button
            className="mb-5 bg-black"
            type="primary"
            onClick={() => setIsRefundModalOpen(true)}
          >
            退票
          </Button>
        )}

        <Table
          columns={columns}
          dataSource={dataSource}
          pagination={{
            total,
            current,
            pageSize,
            showSizeChanger: true,
            pageSizeOptions: ["50", "100", "200", "500", "1000"],
            onShowSizeChange,
          }}
          onChange={onTableChange}
          loading={isDataLoading}
          scroll={{
            x: "max-content",
          }}
        />
      </Card>
      <Modal
        title="編輯訂單資訊"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        destroyOnClose={true}
      >
        <Form
          name="EditForm"
          form={form}
          preserve={false}
          initialValues={record}
        >
          <Form.Item className="hidden" name="id">
            <Input />
          </Form.Item>
          <Form.Item label="name" name="name">
            <Input />
          </Form.Item>
          <Form.Item label="email" name="email">
            <Input />
          </Form.Item>
          <Form.Item label="phone" name="phone">
            <Input />
          </Form.Item>
          <Form.Item label="status" name="status">
            <Select options={orderStatus}></Select>
          </Form.Item>
          <Form.Item label="remark" name="remark">
            <Input.TextArea rows={5} />
          </Form.Item>
        </Form>
      </Modal>
      {/* 退票彈窗 */}
      <Modal
        title="選擇退票"
        open={isRefundModalOpen}
        onOk={handleRefundReasonModalOpen}
        onCancel={handleRefundCancel}
        okText={"退票"}
        width={900}
        destroyOnClose={true}
      >
        <Search
          onSearch={onSearch}
          className="text-left float-start mb-3"
          placeholder="訂單編號 / 姓名 / 電話 / Email"
          enterButton
          allowClear={true}
        />
        <Table
          columns={columns.filter(
            (item) =>
              item.key == "id" ||
              item.key == "name" ||
              item.key == "email" ||
              item.key == "phone",
          )}
          dataSource={dataSource}
          pagination={{
            total,
            current,
            pageSize,
            showSizeChanger: true,
            pageSizeOptions: ["50", "100", "200", "500", "1000"],
            onShowSizeChange,
          }}
          onChange={onTableChange}
          loading={isDataLoading}
          rowSelection={{
            type: "checkbox",
            ...rowSelection,
          }}
        ></Table>
      </Modal>
      {/* 換票彈窗 */}
      <Modal
        title="換票"
        open={isSwitchModalOpen}
        onOk={handleSwitchOk}
        onCancel={handleSwitchCancel}
        confirmLoading={isSwitchConfirmLoading}
        destroyOnClose={true}
      >
        <Form name="EditForm" form={switchForm} preserve={false}>
          <Form.Item label="選擇票券" name="sourceId">
            <Select
              options={movieOptions.filter(
                (item) => item.price == record.price,
              )}
            ></Select>
          </Form.Item>
        </Form>
      </Modal>
      {/* 退票原因彈窗 */}
      <Modal
        title="請說明退票原因"
        open={isRefundReasonModalOpen}
        onOk={handleRefundOk}
        onCancel={() => setIsRefundReasonModalOpen(false)}
        confirmLoading={isRefundReasonLoading}
        destroyOnClose={true}
      >
        <Form name="EditForm" form={reasonForm} preserve={false}>
          <Form.Item label="退票原因" name="reason">
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default JoinList;
